/* eslint-disable import/no-anonymous-default-export */
import type { Theme } from '@mui/material';
import {
    Checkbox,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    useMediaQuery,
    ListItemSecondaryAction,
    Typography
} from '@mui/material';
import {
    RecordContextProvider,
    SimpleListLoading,
    useListContext,
} from 'react-admin';
import { formatRelativeBackendDate } from '@/utils/date_utils';
import { Link } from 'react-router-dom';
import { ProjectFileConfig } from '@/types';

export const ProjectFileConfigListContent = () => {
    const {
        data: project_file_configs,
        error,
        isPending,
        onToggleItem,
        selectedIds,
    } = useListContext<ProjectFileConfig>();
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('md')
    );
    if (isPending) {
        return <SimpleListLoading hasLeftAvatarOrIcon hasSecondaryText />;
    }
    if (error) {
        return null;
    }
    const now = Date.now();

    return (
        <>
            <List dense>
                {project_file_configs.map(item => (
                    <RecordContextProvider key={item.id} value={item}>
                        <ListItem disablePadding>
                            <ListItemButton
                                component={Link}
                                to={`/project_file_configs/${item.id}/show`}
                            >
                                <ListItemIcon sx={{ minWidth: '2.5em' }}>
                                    <Checkbox
                                        edge="start"
                                        checked={selectedIds.includes(
                                            item.id
                                        )}
                                        tabIndex={-1}
                                        disableRipple
                                        onClick={e => {
                                            e.stopPropagation();
                                            onToggleItem(item.id);
                                        }}
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={`${item.title}`}
                                    secondary={
                                        <>
                                            {item.short_name}
                                        </>
                                    }
                                />
                                <ListItemText
                                    primary={item.file_extension}
                                />
                                {item.updated_at && (
                                    <ListItemSecondaryAction
                                        sx={{
                                            top: '10px',
                                            transform: 'none',
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            title={item.updated_at}
                                        >
                                            {!isSmall && 'created at '}
                                            {formatRelativeBackendDate(
                                                item.updated_at,
                                                now
                                            )}
                                        </Typography>
                                    </ListItemSecondaryAction>
                                )}
                            </ListItemButton>
                        </ListItem>
                    </RecordContextProvider>
                ))}

                {project_file_configs.length === 0 && (
                    <ListItem>
                        <ListItemText primary="No project file configs found" />
                    </ListItem>
                )}
            </List>
        </>
    );
};
